/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";

import { LoadingIndicator } from "@quintype/components";
import { SvgHandler } from "../../components/svg-handler/svg-handler";
import loaderIcon from "../../../assets/icons/loading.svg";

function LoadingIndicatorComponent() {
  return (
    <LoadingIndicator>
      <div className="qt-loading-animation qt-theme__color">
        <SvgHandler xlinkHref={loaderIcon} width="24" clazzName="loader" height="24" />
      </div>
    </LoadingIndicator>
  );
}

export { LoadingIndicatorComponent };
